"use client";

import styled, { css } from "styled-components";
import { sans as zoram, fontSize28, fontSize32, lineHeightTight, fontWeightLight } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority2 = css(["margin:0;font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";"], zoram, fontWeightLight, lineHeightTight, fontSize28, props => props.$small ? "" : mediaBreak600w`font-size: ${fontSize32};`);
const H2Styled = styled.h2.withConfig({
  componentId: "sc-42v4-0"
})(["", ";"], internalUseOnlyPriority2);

/**
 * The second level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h2` but be an `h1` (or other heading) if needed.
 * @param {object} props - The component props
 * @param {boolean} [props.small] - Whether smaller styles should be applied
 * @param {React.ReactNode} props.children - The content inside the heading
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., `"div"`) or React component to render
 * @returns {React.ReactNode} The H2 component
 */
const H2 = ({
  small,
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H2Styled, {
  $small: small,
  as: renderAs,
  ...props,
  children: children
});
H2.displayName = "H2";
export default H2;